import {
    extValueTypeMap,
} from './dataMap';

export const ATTR_ID_ENUM = {
    /* 跟后端约定好的硬编码 */
    BRAND_ID: 1000000, // 品牌
    PRODUCE_AREA: 1000001, // 产地
    SPEC: 1000002, // 规格
    STORAGE_TEMPERATURE: 1000003, // 储存条件
    BARCODE: 1000004, // 条码
    IMPORT_FLAG: 1000005, // 是否进口
    SKU_NAME: 1000006, // sku名称
    BG_CATEGORY_ID: 1000010, // 后台分类
    GUARANTEE_PERIOD: 1000011, // 保质期
    UNIT: 1000012, // 基础单位

    /* 前端自己定义的硬编码 */
    COOPERATION_MODE: 1000020, // 合作模式
    YT_TYPE: 1000021, // 业态模式
    OFFLINE_PRICE_TAG_SKU_NAME: 1000022, // 线下价签商品名称
    COMMODITY_NAME: 1000023, // 商品名称
    MARKETING_WORD: 1000024, // 营销词
    REAL_BARCODE: 1000025, // 实物条形码
    PACKAGE_TYPE: 1000026, // 销售形态
    CONSUME_UNIT: 1000027, // 消耗单位
    SPU_NAME: 1000028, // SPU名称

    CAN_SPLIT_SELL: 1000029, // 是否可拆售
    WEIGHT: 1000030, // 重量
    NET_WEIGHT: 1000031, // 净含量
    STORAGE_TEMPERATURE_LEVEL_REMARK: 1000032, // 最佳储存温段
    SPECIAL_ORIGIN: 1000033, // 是否特色产地
    PRODUCT_SIZE: 1000034, // 商品长宽高
    INGREDIENT: 1000035, // 配料表
    INPUT_TAX: 1000036, // 进项税
    STOCK_FLAG: 1000037, // 配方单库存类型
    CITY_BOX_PROPS: 1000038, //  箱规
    CITY_ACCESSORIES: 1000039, //  辅料

    /* 内容信息 */
    LB_PICTURE: 1000040, // 列表用图
    RECOMMEND_SCENE_PICTURE: 1000041, // 猜喜场景商品图
    PRIME_SELECT_PICTURE: 1000042, // 大商卡图
    DLB_PICTURE: 1000043, // 动态列表图
    VIDEO: 1000044, // 商品短视频
    ZT_PICTURE_LIST: 1000045, // 商品主图
    NUTRITIONS: 1000046, // 营养成分表
    ADOPT_RESULT: 1000047, // 是否采纳识别结果
    INGREDIENTS_USE: 1000048, // 配料表
    SUB_TITLE: 1000049, // 副标题
    SKU_SELL_POINT_CONTENT_LISTD_PIC: 1000050, // 推荐理由(卖点)
    DESCRIPTION: 1000051, // 商品详情
};

// 弱校验 AI 推荐核对（type=112）消息中的属性中文名 → attrItemId
export const ATTR_NAME_ID_MAP = Object.freeze({
    品牌: ATTR_ID_ENUM.BRAND_ID,
    产地: ATTR_ID_ENUM.PRODUCE_AREA,
    规格: ATTR_ID_ENUM.SPEC,
    储存条件: ATTR_ID_ENUM.STORAGE_TEMPERATURE,
    条形码: ATTR_ID_ENUM.BARCODE,
    条码: ATTR_ID_ENUM.BARCODE,
    保质期: ATTR_ID_ENUM.GUARANTEE_PERIOD,
    基础单位: ATTR_ID_ENUM.UNIT,
});

export const AI_RECOMMEND_RESULT_STATUS_ENUM = {
    PENDING: 1, // 任务排队中
    RUNNING: 2, // AI推理执行中
    DONE: 3, // 推理完成
    TIMEOUT: 4, // 推理超时
    FEILED: 5, // 推理失败
};

export const CONSISTENT_ENUM = {
    CONSISTENT: 1, // 一致
    INCONSISTENT: 0, // 不一致
    NOT_CALCULATED: -1, // 未计算
};


// 属性类型 attrInputType 枚举
export const ATTR_INPUT_TYPE_ENUM = {
    SINGLE_SELECT: 1, // 单选
    MULTI_SELECT: 2, // 多选
    NUMBER_UNIT: 3, // 输入 + 单位
    TEXT_INPUT: 4,
};

/**
 * 将 recommendedValues JSON 字符串解析为数组。
 * 后端/formatAiRecommendedValues 使用单引号，统一在此替换为双引号后解析。
 * 解析失败返回空数组。
 */
export const parseRecommendedValuesList = (recommendedValues) => {
    if (!recommendedValues) return [];
    try {
        const result = JSON.parse(recommendedValues.replace(/'/g, '"'));
        return Array.isArray(result) ? result : [];
    } catch (e) {
        return [];
    }
};

/**
 * 兼容 recommendedValues 为 JSON 字符串或已解析数组的场景，统一返回数组。
 * 用于弱校验采纳前的入参标准化。
 */
export const normalizeRecommendedValuesList = (recommendedValues) => {
    if (!recommendedValues) return [];
    if (Array.isArray(recommendedValues)) return recommendedValues;
    return parseRecommendedValuesList(recommendedValues);
};

// 解析推荐值展示（key 参数指定从 data 的哪个字段取推荐值，默认 'recommendedValues'）
export const parseRecommendValue = (data, key = 'recommendedValues') => {
    const { attrId, attrInputType } = data;
    const recommendedValues = data[key];
    if (!recommendedValues) return '';
    const result = parseRecommendedValuesList(recommendedValues);
    // 单选
    if (attrInputType === ATTR_INPUT_TYPE_ENUM.SINGLE_SELECT) {
        if (!Array.isArray(result) || !result.length) return '';
        const first = result[0];
        // 产地：结构为 { produceAreaId, produceAreaName, produceAreaType }，取 produceAreaName
        if (Number(attrId) === ATTR_ID_ENUM.PRODUCE_AREA) {
            return first.value || '';
        }
        // 非产地：unit 有值则拼接 value + unit（如"1天"），否则只展示 value
        return first.unit ? `${first.value}${first.unit}` : (first.value ?? '');
    }
    // 多选 输入 直接展示value
    if ([
        ATTR_INPUT_TYPE_ENUM.MULTI_SELECT,
        ATTR_INPUT_TYPE_ENUM.TEXT_INPUT,
    ].includes(attrInputType)) {
        return Array.isArray(result) ? result.map((item) => item.value).join('、') : result;
    }
    // 输入 + 单位
    if (attrInputType === ATTR_INPUT_TYPE_ENUM.NUMBER_UNIT) {
        return Array.isArray(result) ? result.map((item) => `${item.value}${item.unit ? item.unit : ''}`).join('、') : result;
    }
    return '';
};

// 判断扩展属性类型
export const extendAttrInputType = (attr) => {
    const { valueType, categoryExtUnitNames } = attr || {};
    const hasExtUnitOptions = Array.isArray(categoryExtUnitNames) && categoryExtUnitNames.length > 0;
    // 数值型 && categoryExtUnitNames 无值 = TEXT_INPUT 输入（扩展属性）
    if (valueType === extValueTypeMap.NUMBER && !hasExtUnitOptions) {
        return ATTR_INPUT_TYPE_ENUM.TEXT_INPUT; // 4
    }
    // 数值型 && categoryExtUnitNames 有值 = NUMBER_UNIT 输入 + 单位
    if (valueType === extValueTypeMap.NUMBER && hasExtUnitOptions) {
        return ATTR_INPUT_TYPE_ENUM.NUMBER_UNIT; // 3
    }
    // 文本型
    if (valueType === extValueTypeMap.TEXT) {
        return ATTR_INPUT_TYPE_ENUM.TEXT_INPUT; // 4
    }
    // 单选多选 1000001 ，参考 src/pages/lib/extAttrItem.vue 文件判断逻辑
    // 单选
    if (valueType === extValueTypeMap.RADIO || attr.attrId === 1000001) {
        return ATTR_INPUT_TYPE_ENUM.SINGLE_SELECT;
    }
    // 多选
    if (valueType === extValueTypeMap.MULTI && attr.attrId !== 1000001) {
        return ATTR_INPUT_TYPE_ENUM.MULTI_SELECT;
    }
    return null;
};

/**
 * 采纳推荐值——通用字段映射表：attrId → form 字段名
 * 采纳方式由 handleAdoptRecommend 接收的 attrInputType（ATTR_INPUT_TYPE_ENUM）决定：
 *   TEXT_INPUT      → 取 first.value
 *   SINGLE_SELECT   → 取 first.id
 *   MULTI_SELECT    → 取 parsed[].id
 *
 * 所有字段先统一赋值，switch 只负责赋值之后的联动副作用。
 * 消耗单位（NUMBER_UNIT 多字段）例外，保留在 switch 中完整处理。
 */
export const ADOPT_ATTR_MAP = {
    // 输入型
    [ATTR_ID_ENUM.OFFLINE_PRICE_TAG_SKU_NAME]: 'offlinePriceTagSkuName', // 线下价签商品名称
    [ATTR_ID_ENUM.MARKETING_WORD]: 'marketingWord', // 营销词
    [ATTR_ID_ENUM.SPU_NAME]: 'spuName', // SPU名称
    [ATTR_ID_ENUM.SPEC]: 'specActual', // 销售规格
    [ATTR_ID_ENUM.COMMODITY_NAME]: 'commodityName', // 商品名称
    [ATTR_ID_ENUM.REAL_BARCODE]: 'realBarcode', // 实物条形码

    // 单选型
    [ATTR_ID_ENUM.COOPERATION_MODE]: 'cooperationMode', // 合作模式
    [ATTR_ID_ENUM.PACKAGE_TYPE]: 'packageType', // 销售形态
    [ATTR_ID_ENUM.BRAND_ID]: 'brandId', // 品牌

    // 多选型
    [ATTR_ID_ENUM.YT_TYPE]: 'ytTypes', // 业态模式

    // ── 第二步：商品基础信息 ──────────────────────────────────────
    // 输入型
    [ATTR_ID_ENUM.WEIGHT]: 'weight', // 重量
    [ATTR_ID_ENUM.NET_WEIGHT]: 'netWeight', // 净含量
    [ATTR_ID_ENUM.INGREDIENT]: 'ingredient', // 配料表

    // 单选型
    [ATTR_ID_ENUM.STORAGE_TEMPERATURE]: 'storageTemperatureLevel', // 储存条件
    [ATTR_ID_ENUM.STORAGE_TEMPERATURE_LEVEL_REMARK]: 'storageTemperatureLevelRemark', // 最佳储存温段
    [ATTR_ID_ENUM.INPUT_TAX]: 'inputTax', // 进项税
    [ATTR_ID_ENUM.SPECIAL_ORIGIN]: 'specialOrigin', // 是否特色产地
};
